import { Context } from 'Context/Context'
import React, { useContext } from 'react'
import ProfEmailNotification from './EmailNotification';
import AdminEmailNotification from './AdminEmailNotification';
import PlainEmailNotifications from './PlainEmailNotifications';
import ClientEmailNotifications from './ClientEmailNotifications';

function EmailNotifications() {
    const {userDetails} = useContext(Context);
    const loadContent = () => {
        switch(userDetails.role)
        {
            case 2:
                case 5:
                if(userDetails.isUserAssistant)
                {
                    return <PlainEmailNotifications/>
                }
                else
                {
                    return <ProfEmailNotification/>
                }
            
            case 1: 
                return <ClientEmailNotifications/>
            default:
                <></>
        }
    }
  return (
    <>
    {
        loadContent()
    }
    </>
  )
}

export default EmailNotifications